import { trackEvent } from 'iclinic-trackings';

type TrackEndDigitalSigningParams = {
  iclinic_id: string | null;
  physician_id: number | null;
  clinic_id: string | null;
  subscription_id: string | null;
  event_id: string;
  patient_id: string;
  certificate_kind: string;
  certificate_provider: string | null;
};

export async function trackEndDigitalSigning(
  params: TrackEndDigitalSigningParams,
) {
  await trackEvent('button_clicked', {
    application_name: 'iclinic_web',
    application_feature: 'digital_signature',
    button_name: 'end_digital_signing',
    ...params,
  }).catch((error) => error);
}
